import { useTranslation } from "react-i18next";

import NavItem from "./NavItem/NavItem";
import classes from './NavItems.module.css';

const NavItems = (props) => {
    const {t} = useTranslation();
    return (
        <ul className={classes.NavItems}>
            <NavItem link='/#/#home'>{t('menu.home')}</NavItem>
            <NavItem link='/#/#features'>{t('menu.features')}</NavItem>
            <NavItem link='/#/#gallery'>{t('menu.gallery')}</NavItem>
            <NavItem link='/#/#contact'>{t('menu.contact')}</NavItem>
            <NavItem link='/#/#download'>{t('menu.download')}</NavItem>
            <NavItem link='/#/#booking' booking={true}>{t('menu.bookNow')}</NavItem>
        </ul>
    );
}

export default NavItems;